import { ChangeCashMode } from './components/form/model';
import type { ChangeCashSelectorRulesByMode } from './components/form/model';

export const changeCashSelectorRulesByMode: ChangeCashSelectorRulesByMode = {
  [ChangeCashMode.Withdraw]: {
    requireFlags: ['manualWithdrawalOther'],
    excludeConfigIds: ['pliantReferenceCashListId'],
  },
  [ChangeCashMode.Deposit]: {
    requireFlags: ['manualDepositOther'],
    excludeConfigIds: ['pliantReferenceCashListId'],
  },
  [ChangeCashMode.Adjust]: {
    requireFlags: ['manualAdjustment'],
  },
  [ChangeCashMode.Transfer]: {
    outgoing: {
      requireFlags: ['manualTransferOutgoing'],
      excludeConfigIds: ['pliantReferenceCashListId'],
    },
    incoming: {
      requireFlags: ['manualTransferIncoming'],
      excludeConfigIds: ['pliantReferenceCashListId'],
    },
  },
};

/**
 * Explicit "no filtering" rules: every mode shows all cash lists. Pass this
 * deliberately when a selector legitimately must not be flag-filtered — e.g. a
 * dialog that pins the cash list via `forceCashListId`, or a caller that has
 * already filtered the list itself. Required props use this so that showing all
 * cash lists is always an explicit choice, never a forgotten default.
 */
export const UNRESTRICTED_CASH_LIST_RULES_BY_MODE: ChangeCashSelectorRulesByMode =
  {};
